import React, { useState } from 'react';
import './SavingsCalculator.css';

// "How much would you save?" on the plans section: Ownezzy's monthly plan against the usual ways of selling online,
// for the sales and orders the visitor types. The other rows are typical fee structures, not named platforms, and are
// approximate (before GST and payment gateway fees). Visitors in India only: the fees are Indian.

const rupees = (n) => `₹${Math.round(n).toLocaleString('en-IN')}`;

// Each option's cost for a month: sales (₹) and orders
const OPTIONS = [
  { name: 'Website builder: ₹1,499 plan + 2% fee on every sale', cost: (sales) => 1499 + sales * 0.02 },
  { name: 'Store app: 5% + ₹3 on every order', cost: (sales, orders) => sales * 0.05 + orders * 3 },
  { name: 'Marketplace: about 18% commission', cost: (sales) => sales * 0.18 },
];

export default function SavingsCalculator({ planPrice = 399 }) {
  const [sales, setSales] = useState(50000);
  const [orders, setOrders] = useState(100);
  const rows = OPTIONS.map((o) => ({ ...o, total: o.cost(sales, orders) }));
  const cheapest = Math.min(...rows.map((r) => r.total));
  const saveMonth = Math.max(0, cheapest - planPrice);

  return (
    <section className="savings" aria-labelledby="savings-title">
      <div className="savings-head">
        <h3 id="savings-title">How much would you save?</h3>
        <p>Ownezzy is one flat {rupees(planPrice)} a month with 0% commission. Here's what the usual ways of selling online would cost you.</p>
      </div>
      <div className="savings-inputs">
        <label htmlFor="savings-sales">Your sales in a month
          <span className="savings-value">{rupees(sales)}</span>
          <input id="savings-sales" type="range" min="5000" max="500000" step="5000" value={sales} onChange={(e) => setSales(Number(e.target.value))} />
        </label>
        <label htmlFor="savings-orders">Orders in a month
          <span className="savings-value">{orders}</span>
          <input id="savings-orders" type="range" min="10" max="2000" step="10" value={orders} onChange={(e) => setOrders(Number(e.target.value))} />
        </label>
      </div>
      <div className="savings-rows">
        <div className="savings-row is-us"><span>Ownezzy: flat plan, 0% commission</span><b>{rupees(planPrice)}</b></div>
        {rows.map((r) => <div className="savings-row" key={r.name}><span>{r.name}</span><b>{rupees(r.total)}</b></div>)}
      </div>
      <p className="savings-result">
        You keep at least <b>{rupees(saveMonth)}</b> more every month, or <b>{rupees(saveMonth * 12)}</b> a year.
      </p>
      <p className="savings-note">Approximate, before GST and payment gateway fees. Fees are typical of each kind of platform; check a platform's own prices before you compare. With manual UPI, Ownezzy has no gateway fee either.</p>
    </section>
  );
}
